<template>
  <header class="site-header">
    <h1 :class="{ hidden: overridenVisible ? !overridenVisible : !visible }">{{ title }}</h1>
  </header>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      overridenVisible: false
    }
  },
  mounted() {
    const shouldFadeIn = true || (this.$route.params && this.$route.params.slug)
    if (!IS_SERVER && shouldFadeIn) {
      setTimeout(() => this.overridenVisible = true)
      setTimeout(() => this.overridenVisible = false, 5000)
    }

    this.$on('globalReset', () => {
      setTimeout(() => this.overridenVisible = true)
      setTimeout(() => this.overridenVisible = false, 5000)  
    })
  },
  computed: {
    visible() { return false /* !(this.$route.params && this.$route.params.slug) */ },
    ...mapState({
      title: state => state.theme.title
    })
  }
}

</script>
